import { checkCurrentClientUserHasClient } from '@client/common/router/application/routes/check-current-client-user-has-client.route-guard';
import { NoClientLandingPageReachedError } from '@client/feature/home/domain/error/no-client-landing-page-reached.error';
import { loadLazyAppModuleGuard } from '@kiplin/web-common/dependency-injection';
import { container } from '@shared/common/dependency-injection/domain/container';
import { HomeRouteName } from '@shared/feature/home/domain/route/home.route-name';
import { LandingRouteName } from '@shared/feature/landing/application/routes/landing.route-name';
import type { RouteRecordRaw } from 'vue-router';

const HomeAppModule = () => import('@client/feature/home/home.app-module');
const HomePage = () => import('@client/feature/home/application/page/HomePage.vue');

export const homeRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: HomeRouteName.Home,
    beforeEnter: [
      loadLazyAppModuleGuard(HomeAppModule, container),
      () =>
        checkCurrentClientUserHasClient({
          redirectTo: {
            name: LandingRouteName.LandingError,
            query: { errorCode: NoClientLandingPageReachedError.code },
          },
        }),
    ],
    component: HomePage,
  },
];
